var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"viewMethodsPage"},[_c('DetailPure',{attrs:{"detail":_vm.detail}}),_c('NavigatorBar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }